import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-smart-assistant-back",
  "use": "app-icon-smart-assistant-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-smart-assistant-back\"><g stroke=\"#4D4D4D\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 5l-7.071 7.071L11 19.142M5 12h15.203\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol